export default "__VITE_ASSET__D0vRCqWf__"